<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">

            <ng-container *ngIf="currentStep === currentStepTplt.ImportOldData">
                <div class="import-wrapper">
                    <div class="select-input">
                        <div class="file-name">
                            <div class="file-name-inner">{{ fileName }}</div>
                        </div>
                        <div class="select-file" (click)="importInitialMigrationFile()">Parcourir</div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="currentStep === currentStepTplt.MapProfils">
                <form *ngIf="formGroup" class="map-profil-wrapper">
                    <frg-form-input label="Responsable du cabinet" id="responsableCabinet" type="ngSelect"
                        [formGroup]="formGroup" [control]="formGroup.get('responsableCabinet')" required="true" isClearableSelect="false" [selectValue]="cabinetUsers"></frg-form-input>
                    
                    <div class="infos-resp">
                        Cet utilisateur sera utilisé par défaut lors de la migration pour les profils inconnus.
                    </div>

                    <frg-form-input label="Emplacement du dossier 'photos'" id="photosPath"
                        [formGroup]="formGroup" [control]="formGroup.get('photosPath')"></frg-form-input>

                    <ng-container *ngIf="profilsList">
                        <div [formGroup]="formGroup">
                            <div formArrayName="profils">
                              <div *ngFor="let profil of formGroupProfils.controls; index as i">
                                <frg-form-input [formGroupName]="i" [label]="profil.get('oldProfilLibelle').value" id="newProfilId" type="ngSelect"
                                    [formGroup]="profil" [control]="profil.get('newProfilId')" [selectValue]="cabinetUsers"></frg-form-input>
                              </div>
                            </div>
                          </div>
                    </ng-container>
                </form>
            </ng-container>

            <div class="buttons-wrapper">
                <frg-button (activated)="cancel()" backgroundColor="var(--danger)">Annuler</frg-button>

                <ng-container *ngIf="currentStep === currentStepTplt.ImportOldData">
                    <frg-button (activated)="nextStep()">Continuer</frg-button>
                </ng-container>

                <ng-container *ngIf="currentStep === currentStepTplt.MapProfils && formGroup">
                    <frg-button (activated)="submitMigrationConfiguration()" [disabled]="!formGroup.valid">Générer le fichier de migration</frg-button>
                </ng-container>
            </div>

        </div>
    </div>
</div>
<div class="modal-background"></div>